<template>
  <div>
    <div class="pc-block__title">
      {{ $t('pc.documents.create-request') }}
    </div>
    <p>{{ $t('pc.documents.create-request-description') }}</p>
    <validation-observer
      v-slot="{valid}"
      slim
    >
      <validation-provider v-slot="{errors}" rules="required">
        <pc-select
          v-model="formData.doctype"
          :label="$t('pc.documents.choose-doc-type')"
          :options="documentTypes.filter(el => !!el.id && el.is_active && el.user_request_allow)"
          :get-option-label="opt => opt.title[$i18n.locale]"
          class="pc-documents-archive__filter"
        ></pc-select>
      </validation-provider>
      <template v-if="showDateBlock">
        <template v-if="hasPeriod">
          <validation-provider v-slot="{errors}" rules="required|isPastDate">
            <pc-date-input
              v-model="formData.date_from"
              :v-calendar-options="vCalendarOptions"
              :errors="[...getFieldErrors('date_from'),...errors]"
              :label="$t('pc.documents.start-date')"
            />
          </validation-provider>
          <validation-provider v-slot="{errors}" :rules="dateValidator()">
            <pc-date-input
              v-model="formData.date_to"
              :v-calendar-options="vCalendarOptions"
              :errors="[...getFieldErrors('date_to'),...errors]"
              :label="$t('pc.documents.end-date')"
            />
          </validation-provider>
        </template>
        <template v-else-if="hasYear">
          <validation-provider v-slot="{errors}" rules="required">
            <year-picker
              v-model="formData.year"
              :min="vCalendarOptions.minDate.getFullYear()"
              :max="new Date().getFullYear()"
              :errors="[...getFieldErrors('year'), ...errors]"
              placeholder=""
              :label="$t('common.year')"
            />
          </validation-provider>
        </template>
        <template v-else>
          <validation-provider v-slot="{errors}" rules="required|isPastDate">
            <pc-date-input
              v-model="formData.date"
              :errors="[...getFieldErrors('date'), ...errors]"
              :v-calendar-options="vCalendarOptions"
              :label="$t('pc.documents.choose-date')"
            />
          </validation-provider>
        </template>
      </template>
      <pc-button
        class="pc-submit"
        variant="dark"
        :disabled="!valid"
        @click="makeRequest"
      >
        <template v-if="!isLoading">
          {{ $t('pc.documents.request') }}
        </template>
        <icu-icon v-else class="pc-big-loader"></icu-icon>
      </pc-button>

    </validation-observer>
  </div>
</template>

<script>
import IcuIcon from '@/components/common/IcuIcon'
import PcSelect from '@/components/inputs/PcSelect'
import PcDateInput from '@/components/inputs/PcDateInput'
import PcButton from '@/components/common/PcButton'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {mapGetters} from 'vuex'
import {parseISO} from 'date-fns'
import YearPicker from '@/components/common/PcYearPicker.vue'


export default {
  name: 'PcRequestDocument',
  components: {
    YearPicker,
    ValidationObserver,
    ValidationProvider,
    PcButton,
    PcDateInput,
    PcSelect,
    IcuIcon
  },
  props: {
    backendErrors: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      isLoading: false,
      vCalendarOptions:{
        maxDate:  new Date(new Date().setDate(new Date().getDate()-1)),
        minDate: new Date('2023-01-01'),
      },
      formData: {
        doctype: null,
        date: null,
        date_from: null,
        date_to: null,
        year: null
      }
    }
  },
  watch: {
    'formData.date_to' (val) {
      this.setDefaultDate(val, 'date_to')
    },
    'formData.date_from' (val) {
      this.setDefaultDate(val, 'date_from')
    },
    'formData.date' (val) {
      this.setDefaultDate(val, 'date')
    },
    backendErrors () {
      this.isLoading = false
    }
  },
  computed: {
    ...mapGetters(['documentTypes']),
    docType() {
       const index = this.documentTypes.findIndex(el=> el.id == this.formData.doctype)
       return this.documentTypes[index]
    },
    hasPeriod() {
      return this.docType && this.docType.date_type === 'PERIOD'
    },

    hasYear() {
      return this.docType && this.docType.date_type === 'YEAR'
    },

    showDateBlock() {
      return this.docType && !!this.docType.date_type
    }
  },
  methods: {
    getFieldErrors(fieldName) {
      return this.backendErrors[fieldName] ?? []
    },
    setDefaultDate(val){
      const date = parseISO(val)
      this.$set(this.vCalendarOptions, 'dates', date)
    },
    dateValidator() {
      return {
        required: true,
        isPastDate: true,
        isCorrectDateRange: {startDate: this.formData.date_from }
      }
    },
    makeRequest() {
      if(!this.isLoading) {
        this.isLoading = true
        const data = {}
        for (const key in this.formData) {
          if (this.formData[key]) {
            data[key] = this.formData[key]
          }
        }

        this.$emit('request', data, this.clearForm)
      }
    },

   clearForm() {
      this.isLoading = false
     for (const key in this.formData) {
       this.formData[key] = null
     }
   }
  }
}
</script>

<style scoped lang="scss">

@import "~@/assets/scss/theme.scss";
.pc-documents-archive__filter {
  margin-bottom: 38px;
  margin-top: 38px;
  min-width: 336px;
  flex-shrink: 0;
}

.pc-submit {
  margin-top: 16px;
  min-width: 280px;
  @media (max-width: $tablet){
    width: 100%;
  }
}
</style>
